import { Star } from '@mui/icons-material';
import { styled } from '@mui/material/styles';

import { CopperRose } from '../../StyleGuide/Colors';

export const BirthPlanStarIcon = styled(Star)({
  fontSize: 16,
  color: CopperRose
});
